import { theme } from "@clearabee/ui-library-base";
import React, { useState, useContext, createContext } from "react";
import { TouchableOpacity, View } from "react-native";
import { Heading } from "../../Core/Heading/Heading";
import { Icon } from "../../Core/Icon/Icon";
import { styles } from "./Accordion.styles";
export const AccordionContext = createContext({});
const AccordionComponent = ({ initial, iconColor, buttonColor, headingColor, contentBackgroundColor, itemBackgroundColor, singular = false, children, styles: userStyles, ...rest }) => {
    const [openItems, setOpenItems] = useState(initial ? [initial] : []);
    const open = (index) => {
        setOpenItems((currentOpen) => {
            if (!currentOpen.includes(index)) {
                return [...(!singular ? currentOpen : []), index];
            }
            return currentOpen;
        });
    };
    const close = (index) => {
        setOpenItems((currentOpen) => currentOpen.filter((i) => i !== index));
    };
    const toggle = (index) => {
        setOpenItems((currentOpen) => {
            if (!currentOpen.includes(index)) {
                return [...(!singular ? currentOpen : []), index];
            }
            return currentOpen.filter((i) => i !== index);
        });
    };
    const reset = () => setOpenItems(initial ? [initial] : []);
    return (React.createElement(AccordionContext.Provider, { value: {
            initial,
            iconColor,
            buttonColor,
            headingColor,
            contentBackgroundColor,
            itemBackgroundColor,
            singular,
            openItems,
            setOpenItems,
            open,
            close,
            toggle,
            reset,
        } },
        React.createElement(View, { style: userStyles, ...rest }, children)));
};
const AccordionItem = ({ label, children, index = "", slim, ...rest }) => {
    const { openItems, toggle, iconColor = "dark", buttonColor = "accent", headingColor = "dark", itemBackgroundColor = "light", contentBackgroundColor, } = useContext(AccordionContext);
    // Allows the item to be used on it's own outside of an accordion context
    const [internalOpen, setInternalOpen] = useState(false);
    const isOpen = openItems ? index && openItems.includes(index) : internalOpen;
    return (React.createElement(View, { ...rest },
        React.createElement(View, null,
            React.createElement(TouchableOpacity, { testID: `accordionItemTouchableOpacity${index}`, style: [
                    styles.touchableOpacity,
                    itemBackgroundColor && styles[itemBackgroundColor],
                    slim && styles.slim,
                ], onPress: () => toggle && index ? toggle(index) : setInternalOpen(!internalOpen) },
                React.createElement(Heading, { testID: `accordionItemHeading${index}`, color: headingColor, level: 6, styles: styles.heading }, label),
                React.createElement(View, { testID: `accordionButton${index}`, style: [
                        styles.button,
                        buttonColor && styles[buttonColor],
                        slim && styles.slimButton,
                    ] }, index && openItems?.includes(index) ? (React.createElement(Icon.Minus, { size: "small", color: iconColor })) : (React.createElement(Icon.Plus, { size: "small", color: iconColor })))),
            isOpen && (React.createElement(View, { style: [
                    styles.contentContainer,
                    contentBackgroundColor
                        ? { backgroundColor: contentBackgroundColor }
                        : { backgroundColor: `${theme.colors.greyscale.lightest}60` },
                ] }, children)))));
};
AccordionComponent.Item = AccordionItem;
export const Accordion = AccordionComponent;
//# sourceMappingURL=Accordion.js.map